import React, { createContext, ReactNode, useState, useMemo } from 'react';

// 選択された駅の型定義
export type SelectStation = {
  stationCode?: string;
  lineCode?: string;
};

// Context に渡す値の型定義
export type SelectStationContextType = {
  selectStationList: SelectStation[];
  setSelectStationList: React.Dispatch<React.SetStateAction<SelectStation[]>>;
};

// Context の作成（デフォルト値は undefined にする）
export const SelectStationContext = createContext<
  SelectStationContextType | undefined
>(undefined);

type SelectStationProviderProps = {
  children: ReactNode;
};

export const SelectStationProvider = ({
  children,
}: SelectStationProviderProps) => {
  const [selectStationList, setSelectStationList] = useState<SelectStation[]>(
    []
  );

  const selectStationContextValue = useMemo(
    () => ({ selectStationList, setSelectStationList }),
    [selectStationList]
  );

  return (
    <SelectStationContext.Provider value={selectStationContextValue}>
      {children}
    </SelectStationContext.Provider>
  );
};
